











































import {mixins} from "vue-class-component";
import {Component} from "vue-property-decorator";
import {CommonMixin} from "@/shared/services/mixin";
import {DistrictStore} from "@/modules/regionsv2/district/store";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import DistrictSearch from "@/modules/regionsv2/district/components/Search/index.vue";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import {CommonStatus} from "@/enums/status";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import DistrictAction from "@/modules/regionsv2/district/components/Action/index.vue";
import DistrictForm from "@/modules/regionsv2/district/Form/index.vue";
import ProvinceLabelV2 from "@/modules/regionsv2/ProvinceLabelV2/index.vue";

const columns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        width: 20
    },
    {
        title: 'Tên phường/xã',
        dataIndex: 'name',
        key: 'name',
        scopedSlots: { customRender: 'name' },
        width: 100
    },
    {
        title: 'Tỉnh/tp',
        dataIndex: 'provinceId',
        key: 'provinceId',
        scopedSlots: { customRender: 'provinceId' },
        width: 100
    },
    {
        title: 'Trạng thái',
        dataIndex: 'status',
        key: 'status',
        scopedSlots: { customRender: 'status' },
        width: 100
    },
    {
        title: 'Thao tác',
        dataIndex: 'id',
        key: 'action',
        scopedSlots: { customRender: 'action' },
        width: 50
    }
]
@Component({
    name: "DistrictList",
    components: {
        ProvinceLabelV2,
        DistrictForm, DistrictAction, EnumSelector, CommonStatusLabel, DistrictSearch}
})
export default class extends mixins(CommonMixin) {
    columns = columns;
    CommonStatus = CommonStatus;

    get dataSource() {
        return DistrictStore.districts;
    }

    get pagination() {
        return {
            current: DistrictStore.meta.page,
            pageSize: DistrictStore.meta.limit,
            total: DistrictStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} tỉnh`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        DistrictStore.paramsChangeDistrictV21({...DistrictStore.params, page: pagination.current, limit: pagination.pageSize});
    }
}
